/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import TelemetryLevelMapping from '../metrics/TelemetricLevelMapping';
import TelemetryDefault from '../metrics/TelemetryDefault';
import LoggingLevelMapping from '../logger/LoggingLevelMapping';
import LoggerDefaults from '../logger/LoggerDefaults';

// The PlainConfigurationParameterReader file is used in the silent build
// to constrain the configuration parameters to the specified values.
export default class PlainConfigurationParameterReader {
  public static getStringValue(name: string): string {
    return PlainConfigurationParameterReader.defaultStringValue[name];
  }

  public static getBooleanValue(name: string): boolean {
    return PlainConfigurationParameterReader.defaultBooleanValue[name];
  }

  private static get defaultStringValue(): { [name: string]: string } {
    return {
      'phenix-metrics-level': TelemetryLevelMapping.convertTelemetryLevelToTelemetryLevelType(TelemetryDefault.defaultTelemetryLevel),
      'phenix-logging-level': LoggingLevelMapping.convertLoggingLevelToLoggingLevelType(LoggerDefaults.defaultLoggingLevel),
      'phenix-console-logging-level': LoggingLevelMapping.convertLoggingLevelToLoggingLevelType(LoggerDefaults.defaultConsoleLoggingLevel),
      'phenix-telemetry-logging-level': LoggingLevelMapping.convertLoggingLevelToLoggingLevelType(LoggerDefaults.defaultTelemetryLoggingLevel),
      'phenix-channel-token': '',
      'phenix-uri': '',
      'phenix-base-uri': ''
    };
  }

  private static get defaultBooleanValue(): { [name: string]: boolean } {
    return {
      'phenix-automatically-retry-on-failure': true,
      'phenix-automatically-reconnect-peer-connection': true,
      'phenix-force-garbage-collection-on-restart': true,
      'phenix-skip-garbage-collection-on-mobile-devices': true
    };
  }
}